"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontTypeIconAlignmentMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../components/Icon/Icon.styles");
/** @mixin fontTypeIconAlignmentMixin */
/**
 * Align Icons with the `fontType` of the component.
 * Alignment is based on the font size and line height of the `fontType` provided.
 *
 * @example
 * import { fontTypeIconAlignmentMixin, IconHeart } from '@zillow/constellation';
 *
 * const Component = styled.p`
 *     ${fontTypeIconAlignmentMixin}
 * `;
 *
 * <Component fontType="h1">
 *     I <IconHeart /> Seattle
 * </Component>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontType] - A key for `fontSizes` and `lineHeights` objects on the theme.
 * @param {boolean} [props.fontTypeIconAlignment=true] - true to enable alignment, false to disable
 * @param {object} props.theme - The styled-components theme object with `fontSizes` and
 *     `lineHeights` objects.
 * @return {CSSObject}
 */
var fontTypeIconAlignmentMixin = function fontTypeIconAlignmentMixin(props) {
  var fontType = props.fontType,
    _props$fontTypeIconAl = props.fontTypeIconAlignment,
    fontTypeIconAlignment = _props$fontTypeIconAl === void 0 ? true : _props$fontTypeIconAl;
  if (!fontType || !fontTypeIconAlignment) {
    return '';
  }
  return (0, _styledToken.default)({
    lineHeights: 'lineHeights',
    fontSizes: 'fontSizes'
  }, function (_ref) {
    var lineHeights = _ref.lineHeights,
      fontSizes = _ref.fontSizes;
    var lineHeight = lineHeights && lineHeights[fontType];
    var fontSize = fontSizes && fontSizes[fontType];
    if (!lineHeight || !fontSize) {
      return '';
    }
    return (0, _styledComponents.css)(["> ", "{margin-top:", "px;}"], _Icon.StyledIcon, (lineHeight - fontSize) / 2);
  })(props);
};
exports.fontTypeIconAlignmentMixin = fontTypeIconAlignmentMixin;